import React from "react";
import { Grid } from "@mui/material";
import HFRProgressionChart from "./HFRProgressionChart";
import StarEccentricityChart from "./StarEccentricityChart";
import DetectedStarsChart from "./DetectedStarsChart";
import TemperatureFocusChart from "./TemperatureFocusChart";
import { ImageMetadata } from "../types";

interface QualityTabPanelProps {
  imagesForView: ImageMetadata[];
}

const QualityTabPanel: React.FC<QualityTabPanelProps> = ({ imagesForView }) => (
  <Grid container spacing={3}>
    {/* HFR Progression */}
    <Grid size={{ xs: 12, md: 6 }}>
      <HFRProgressionChart imagesForView={imagesForView} />
    </Grid>
    {/* Star Eccentricity */}
    <Grid size={{ xs: 12, md: 6 }}>
      <StarEccentricityChart imagesForView={imagesForView} />
    </Grid>
    {/* Detected Stars */}
    <Grid size={{ xs: 12, md: 6 }}>
      <DetectedStarsChart imagesForView={imagesForView} />
    </Grid>
    {/* Temperature & Focus */}
    <Grid size={{ xs: 12, md: 6 }}>
      <TemperatureFocusChart imagesForView={imagesForView} />
    </Grid>
  </Grid>
);

export default QualityTabPanel;
